<template>
  <QuoteReferenceNumber
      :car-brand="carInfo.makeModel"
      car-model=""
      :car-year="carInfo.modelYear"
      hotline="800 4742"
      whats-app="97451047909"
      :quote-od="convertOdQuoteToString"
      :quote-tpl="convertTplQuoteToString"
  />
</template>

<script>
import { QuoteReferenceNumber } from 'qic-components'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'QuoteReference',
  components: { QuoteReferenceNumber },
  computed: {
    ...mapState({
      carInfo: state => state.renew.policyInfo
    }),
    ...mapGetters({
      odQuote: 'odQuoteNumber',
      tplQuote: 'tplQuoteNumber'
    }),
    convertOdQuoteToString () {
      return this.odQuote ? this.odQuote.toString() : ''
    },
    convertTplQuoteToString () {
      return this.tplQuote ? this.tplQuote.toString() : ''
    }
  }
}
</script>

<style lang="scss">
.rtl .quote-reference__title {
  margin-left: 4px;
}
</style>
